import querystring from 'query-string'
import { customHistory as history } from '../routingHelper/routerHistory'
import {
  isHistoryAvailable,
  pushNewStateToHistory,
} from '../filter/setUrlFilterParams'

export const SBS_ROUTES = {
  1: 'slice1',
  2: 'slice2',
  3: 'slice3',
  4: 'slice4',
  5: 'slice5',
}

export function setSbsRouteParam(sliceId = SBS_ROUTES[1]) {
  if (!isHistoryAvailable) {
    return
  }

  const queryObj = querystring.parse(history.location.search)

  queryObj.sbsroute = sliceId

  pushNewStateToHistory(queryObj)
}
